(function (module){
    'use strict';

    /** @ngInject */
    function msCardDirective(){
        return {
            restrict: 'E',
            scope: {
                templatePath: '=template',
                card: '=ngModel',
                vm: '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile: (tElement)=> {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement){
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded(){
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }

    module
        .directive('msCard', msCardDirective);

})(angular.module('rocket.components'));
